
export { default as anyPass } from "./anyPass.js"
export { default as compose } from "./compose.js"
export { default as dropWhile } from "./dropWhile.js"
export { default as lte } from "./lte.js"
export { default as prop } from "./prop.js"